import { Component, OnInit } from '@angular/core';
import { InventarioService } from 'src/app/services/inventario.service';
import Swal from 'sweetalert2';
import { mensajeSesionExpiradaService } from 'src/app/services/mensajeSesionExpirada.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-listadxmlcontabilidad',
  templateUrl: './listadxmlcontabilidad.component.html',
  styleUrls: ['./listadxmlcontabilidad.component.css']
})
export class ListadxmlcontabilidadComponent implements OnInit {

  facturas: any[] = [];
  facturasFiltradas: any[] = [];
  facturasPaginadas: any[] = [];

  facturasSeleccionadas: number[] = [];
  facturasSeleccionadasMap: { [key: number]: boolean } = {};

  polizas: any = [];
  id: any = [];

  textoBusqueda: string = '';

  poliza = {
    mes: '',
    tipo: '',
    numero: '',
    tipo_operacion: '',
    descripcion: '',
    fecha_creacion: '' 
  };

  facturasPoliza: any[] = [];
  totalFacturasPoliza: number = 0;
  polizaSeleccionadaId: number | null = null;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();

  // PAGINACIÓN agregar
  paginaActual: number = 1;
  itemsPorPagina: number = 5;
  totalPaginas: number = 0;

  //  EDICIÓN (FIX TS)
  polizaEdit: any = {};
  facturasPolizaEdit: any[] = [];
  facturasDisponiblesEdit: any[] = [];
  facturasEditIds: number[] = [];

  // 🔹 PAGINACIÓN AGREGAR FACTURAS (MODAL EDITAR)
  paginaActualEdit: number = 1;
  itemsPorPaginaEdit: number = 5;
  totalPaginasEdit: number = 0;
  facturasDisponiblesEditPaginadas: any[] = [];

  // 🔥 NUEVO: PAGINACIÓN FACTURAS EN PÓLIZA
  paginaActualPolizaEdit: number = 1;
  itemsPorPaginaPolizaEdit: number = 5;
  totalPaginasPolizaEdit: number = 0;
  facturasPolizaEditPaginadas: any[] = [];

  constructor(
    private inventarioService: InventarioService,
    private msj: mensajeSesionExpiradaService
  ) {}

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      order: [[0, 'asc']],
      language: {
        url: 'https://cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json'
      }
    };

    this.getPolizas();
    this.cargarFacturas();
  }

  getPolizas() {
    this.inventarioService.getPolizaslistaRH().subscribe(
      res => {
        if (res === 'TOKEN-EXPIRADO') {
          this.msj.tokenExpiradoCerrarSesion();
          return;
        }
        this.polizas = res;
        this.dtTrigger.next();
      },
      err => console.error(err)
    );
  }

cargarFacturas() {
  this.inventarioService.getFacturasSinPoliza()
    .subscribe((resp: any) => {

      resp.forEach((f: any) => {

        // 🔥 IMPORTES
        f.exento = Number(f.exento || 0);
        f.tasa0 = Number(f.tasa0 || 0);
        f.tasa16 = Number(f.tasa16 || 0);
        f.subtotal = Number(f.subtotal || 0);
        f.iva = Number(f.iva || 0);
        f.isr = Number(f.isr || 0);
        f.ajuste = Number(f.ajuste || 0);
        f.total = Number(f.total || 0);

        // 🔥 DEFAULT TIPO TERCERO
        if (!f.tipo_tercero) {
          f.tipo_tercero = '04'; // PROVEEDOR NACIONAL
        }

        // 🔥 DEFAULT TIPO OPERACIÓN
        if (!f.tipo_operacion) {
          f.tipo_operacion = '85'; // OTROS
        }

        // 🔥 DEFAULT EFECTOS FISCALES
        if (!f.efectos_fiscal) {
          f.efectos_fiscal = '01'; // SI
        }
      });

      this.poliza.fecha_creacion = new Date().toISOString().split('T')[0];

      this.facturas = resp;
      this.facturasFiltradas = resp;
      this.paginaActual = 1;
      this.paginarFacturas();
    });
}

  filtrarFacturas() {
    const texto = this.textoBusqueda.toLowerCase();

    this.facturasFiltradas = this.facturas.filter(f =>
      (f.folio && f.folio.toLowerCase().includes(texto)) ||
      (f.nombre_emisor && f.nombre_emisor.toLowerCase().includes(texto)) ||
      (f.uuid && f.uuid.toLowerCase().includes(texto)) ||
      (f.total && f.total.toString().includes(texto)) ||
      (f.tipoprestacion && f.tipoprestacion.toString().includes(texto))
    );

    this.paginaActual = 1;
    this.paginarFacturas();
  }

  seleccionarFactura(id: number) {
    this.facturasSeleccionadasMap[id] = !this.facturasSeleccionadasMap[id];

    this.facturasSeleccionadas = Object.keys(this.facturasSeleccionadasMap)
      .filter(key => this.facturasSeleccionadasMap[+key])
      .map(key => +key);
  }

guardarPoliza() {
  if (this.facturasSeleccionadas.length === 0) {
    Swal.fire({
      title: 'Error',
      text: 'Selecciona al menos una factura',
      icon: 'warning',
      confirmButtonColor: '#6D1A36' // vino
    });
    return;
  }

  const facturasData = this.facturas
    .filter(f => this.facturasSeleccionadas.includes(f.id))
    .map(f => ({
  id: f.id,
  tipo_tercero: f.tipo_tercero,
  tipo_operacion: f.tipo_operacion,
  efectos_fiscal: f.efectos_fiscal,

exento: Number(f.exento || 0),
tasa0: Number(f.tasa0 || 0),
tasa16: Number(f.tasa16 || 0),
subtotal: Number(f.subtotal || 0),
iva: Number(f.iva || 0),
isr: Number(f.isr || 0),
ajuste: Number(f.ajuste || 0),
total: Number(f.total || 0) + Number(f.ajuste || 0)
}));

  const body = {
    poliza: this.poliza,
    facturas: facturasData
  };

  this.inventarioService.crearPoliza(body).subscribe({
    next: () => {

      Swal.fire({
        title: 'OK',
        text: 'Póliza creada correctamente',
        icon: 'success',
        confirmButtonColor: '#6D1A36' // vino
      });

      this.facturasSeleccionadas = [];
      this.facturasSeleccionadasMap = {};
      this.textoBusqueda = '';
      this.cargarFacturas();

      setTimeout(() => {
        window.location.reload();
      }, 1000);

    },
    error: (err) => {

      Swal.fire({
        title: 'Error',
        text: err.status === 400 && err.error?.msg
          ? err.error.msg
          : 'Ocurrió un problema al guardar la póliza',
        icon: 'error',
        confirmButtonColor: '#6D1A36' // vino
      });

    }
  });
}

  trackById(index: number, item: any) {
    return item.id;
  }

  verpoliza(id: number) {
    this.facturasPoliza = [];
    this.totalFacturasPoliza = 0;

    this.inventarioService.getpolizasId(id).subscribe(
      (res: any) => {
        if (res === 'TOKEN-EXPIRADO') {
          this.msj.tokenExpiradoCerrarSesion();
          return;
        }

        this.facturasPoliza = res;
        this.totalFacturasPoliza = this.facturasPoliza.reduce(
          (acc, f) => acc + Number(f.total || 0),
          0
        );

        ($('#VerPoliza') as any).modal('show');
      },
      err => console.error(err)
    );
  }

  paginarFacturas() {
    this.totalPaginas = Math.ceil(this.facturasFiltradas.length / this.itemsPorPagina);

    const inicio = (this.paginaActual - 1) * this.itemsPorPagina;
    const fin = inicio + this.itemsPorPagina;

    this.facturasPaginadas = this.facturasFiltradas.slice(inicio, fin);
  }

  cambiarPagina(pagina: number) {
    if (pagina < 1 || pagina > this.totalPaginas) return;
    this.paginaActual = pagina;
    this.paginarFacturas();
  }

abrirEditarPoliza(poliza: any) {

  this.polizaEdit = { ...poliza };
  this.polizaSeleccionadaId = poliza.id;

  // 🔥 FORMATEAR FECHA PARA INPUT DATE
  if (this.polizaEdit.fecha_creacion) {
    this.polizaEdit.fecha_creacion =
      new Date(this.polizaEdit.fecha_creacion).toISOString().split('T')[0];
  } else {
    this.polizaEdit.fecha_creacion =
      new Date().toISOString().split('T')[0];
  }

  this.inventarioService.getpolizasId(poliza.id).subscribe((res: any[]) => {

    this.facturasPolizaEdit = res;

    // 🔥 DEFAULTS TAMBIÉN AQUÍ
    this.facturasPolizaEdit.forEach((f: any) => {

      if (!f.tipo_tercero) f.tipo_tercero = '04';
      if (!f.tipo_operacion) f.tipo_operacion = '85';
      if (!f.efectos_fiscal) f.efectos_fiscal = '01';

      f.exento = Number(f.exento || 0);
      f.tasa0 = Number(f.tasa0 || 0);
      f.tasa16 = Number(f.tasa16 || 0);
      f.subtotal = Number(f.subtotal || 0);
      f.iva = Number(f.iva || 0);
      f.isr = Number(f.isr || 0);
      f.ajuste = Number(f.ajuste || 0);
      f.total = Number(f.total || 0);

    });

    this.facturasEditIds = res.map(f => Number(f.id_factura));

    this.paginaActualPolizaEdit = 1;
    this.paginarFacturasPolizaEdit();

  });

  this.inventarioService.getFacturasSinPoliza().subscribe((res: any[]) => {

    // 🔥 DEFAULTS TAMBIÉN PARA LAS NUEVAS
    res.forEach((f: any) => {

      if (!f.tipo_tercero) f.tipo_tercero = '04';
      if (!f.tipo_operacion) f.tipo_operacion = '85';
      if (!f.efectos_fiscal) f.efectos_fiscal = '01';

      f.exento = Number(f.exento || 0);
      f.tasa0 = Number(f.tasa0 || 0);
      f.tasa16 = Number(f.tasa16 || 0);
      f.subtotal = Number(f.subtotal || 0);
      f.iva = Number(f.iva || 0);
      f.isr = Number(f.isr || 0);
      f.ajuste = Number(f.ajuste || 0);
      f.total = Number(f.total || 0);

    });

    this.facturasDisponiblesEdit = res;

    this.paginaActualEdit = 1;
    this.paginarFacturasEdit();

  });

}

  quitarFacturaEdit(id: number) {

    const factura = this.facturasPolizaEdit.find(f => f.id_factura === id);

    this.facturasEditIds =
      this.facturasEditIds.filter(x => x !== id);

    this.facturasPolizaEdit =
      this.facturasPolizaEdit.filter(f => f.id_factura !== id);

    if (factura) {
      this.facturasDisponiblesEdit.push(factura);
    }

    this.paginarFacturasEdit();

    // 🔥 NUEVO
    this.paginarFacturasPolizaEdit();
  }

  agregarFacturaEdit(id: number) {

    const factura = this.facturasDisponiblesEdit.find(f => f.id === id);

    if (!factura) return;

    if (!this.facturasEditIds.includes(id)) {
      this.facturasEditIds.push(id);
    }

    this.facturasPolizaEdit.push(factura);

    this.facturasDisponiblesEdit =
      this.facturasDisponiblesEdit.filter(f => f.id !== id);

    this.paginarFacturasEdit();

    // 🔥 NUEVO
    this.paginarFacturasPolizaEdit();
  }

guardarEdicionPoliza() {

 const facturasData = this.facturasPolizaEdit.map(f => ({
  id: f.id_factura || f.id,

  tipo_tercero: f.tipo_tercero,
  tipo_operacion: f.tipo_operacion,
  efectos_fiscal: f.efectos_fiscal,

  exento: Number(f.exento || 0),
tasa0: Number(f.tasa0 || 0),
tasa16: Number(f.tasa16 || 0),
subtotal: Number(f.subtotal || 0),
iva: Number(f.iva || 0),
isr: Number(f.isr || 0),
ajuste: Number(f.ajuste || 0),
total: Number(f.total || 0) + Number(f.ajuste || 0)
}));

  const body = {
    poliza: this.polizaEdit,
    facturas: facturasData
  };

  this.inventarioService.actualizarPoliza(
    this.polizaSeleccionadaId!,
    body
  ).subscribe({
    next: () => {

      Swal.fire({
        title: 'OK',
        text: 'Póliza actualizada',
        icon: 'success',
        confirmButtonColor: '#6D1A36' // 🍷 vino
      });

      setTimeout(() => window.location.reload(), 1000);

    },
    error: err => {

      Swal.fire({
        title: 'Error',
        text: err.error?.msg || 'Error al actualizar',
        icon: 'error',
        confirmButtonColor: '#6D1A36' // 🍷 vino
      });

    }
  });

}

  paginarFacturasEdit() {
    this.totalPaginasEdit = Math.ceil(
      this.facturasDisponiblesEdit.length / this.itemsPorPaginaEdit
    );

    const inicio = (this.paginaActualEdit - 1) * this.itemsPorPaginaEdit;
    const fin = inicio + this.itemsPorPaginaEdit;

    this.facturasDisponiblesEditPaginadas =
      this.facturasDisponiblesEdit.slice(inicio, fin);
  }

  cambiarPaginaEdit(pagina: number) {
    if (pagina < 1 || pagina > this.totalPaginasEdit) return;

    this.paginaActualEdit = pagina;
    this.paginarFacturasEdit();
  }

  // 🔥 NUEVOS MÉTODOS
  paginarFacturasPolizaEdit() {
    this.totalPaginasPolizaEdit = Math.ceil(
      this.facturasPolizaEdit.length / this.itemsPorPaginaPolizaEdit
    );

    const inicio = (this.paginaActualPolizaEdit - 1) * this.itemsPorPaginaPolizaEdit;
    const fin = inicio + this.itemsPorPaginaPolizaEdit;

    this.facturasPolizaEditPaginadas =
      this.facturasPolizaEdit.slice(inicio, fin);
  }

  cambiarPaginaPolizaEdit(pagina: number) {
    if (pagina < 1 || pagina > this.totalPaginasPolizaEdit) return;

    this.paginaActualPolizaEdit = pagina;
    this.paginarFacturasPolizaEdit();
  }

eliminarPoliza(id: number) {

  Swal.fire({
    title: '¿Eliminar póliza?',
    text: 'Se eliminará la póliza y se liberarán sus facturas',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',

    // 🎨 COLORES PERSONALIZADOS
    confirmButtonColor: '#6D1A36', // vino
    cancelButtonColor: '#6c757d'   // gris (bootstrap)
  }).then((result) => {

    if (result.isConfirmed) {

      this.inventarioService.eliminarPoliza(id)
        .subscribe({
          next: () => {

            Swal.fire({
              title: 'Eliminada',
              text: 'La póliza fue eliminada correctamente',
              icon: 'success',
              confirmButtonColor: '#6D1A36' // vino
            });

            setTimeout(() => {
              window.location.reload();
            }, 1000);

          },
          error: () => {
            Swal.fire({
              title: 'Error',
              text: 'No se pudo eliminar la póliza',
              icon: 'error',
              confirmButtonColor: '#6D1A36'
            });
          }
        });

    }

  });

}

calcularTotal(f: any): number {
  return Number(f.total || 0) + Number(f.ajuste || 0);
}


}